import React from 'react'
import AwesomeError, { AwesomeErrorButton } from 'components/Common/AwesomeError'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { connect } from 'react-redux'
import { getSupportContact } from 'selectors/supportContactSelector'
import BodyText from 'components/Luxkit/Typography/BodyText'

interface Props {
  currentContact: App.GeoContacts;
  className?: string;
  canSwitchToHotel?: boolean;
}

function OfferCalendarNoFlightsMessage(props: Props) {
  const dispatch = useOfferPageDispatch()

  const onClick = () => {
    dispatch({ type: OfferPageActions.setFlights, flights: false })
  }

  return (
    <AwesomeError title="No flights available" className={props.className}>
      <BodyText variant="large">
        Unfortunately we couldn’t find any flights for the travel{' '}
        dates you selected. Try selecting new travel dates or give our{' '}
        flights team a call on{' '}
        <a
          href={`tel:${props.currentContact.local.number}`}
          rel="nofollow">{props.currentContact.local.humanReadable}
        </a>.
      </BodyText>
      {props.canSwitchToHotel && <AwesomeErrorButton onClick={onClick}>
        View hotel only prices
      </AwesomeErrorButton>}
    </AwesomeError>
  )
}

function mapStateToProps(state: App.State) {
  return {
    currentContact: getSupportContact(state),
  }
}

export default connect(mapStateToProps)(React.memo(OfferCalendarNoFlightsMessage))
